import React from 'react';
import '../css/pages/Home.css';

function Home() {

  return (
    <div className="container-home">
      <section className="section-home">
        <h1
          className="home-name"
        >
          Flavio Bianchetti
        </h1>
        <p
          className="home-description"
        >
          Desenvolvedor Web
        </p>
        <section className="section-animation">
          <div className="container-animation">
            <div className="div-animation div-blue">
              <p
                className="p-animation p-blue"
                translate="no"
              >
                GitHub
              </p>
            </div>
            <div className="div-animation div-red">
              <p
                className="p-animation p-red"
                translate="no"
              >
                HTML
              </p>
            </div>
            <div className="div-animation div-green">
              <p
                className="p-animation p-green"
                translate="no"
              >
                CSS
              </p>
            </div>
            <div className="div-animation div-yellow">
              <p
                className="p-animation p-yellow"
                translate="no"
              >
                JS
              </p>
            </div>
            <div className="div-animation div-purple">
              <p
                className="p-animation p-purple"
                translate="no"
              >
                React
              </p>
            </div>
            <div className="div-animation div-orange">
              <p
                className="p-animation p-orange"
                translate="no"
              >
                Redux
              </p>
            </div>
          </div>
        </section>
      </section>
    </div>
  );
}

export default Home;
